import { Button, Grid, IconButton, Popover, Divider, Tooltip } from '@mui/material';
import { useEffect, useState } from 'react';
import { HorizontalEllipsisIcon } from '../../../assets/icons';
import { desktopHeaderStyles } from './styles';
import { DropdownMenuList } from './DropdownMenuList';
import { useLocation, Link } from 'react-router-dom';
import { AppIcon } from '../../app-icon/AppIcon';
import { MenuWithChildren } from '../../../types/menu';

interface DesktopHeaderMoreMenuProps {
  menus: MenuWithChildren[];
}
export const DesktopHeaderMoreMenu: React.FC<DesktopHeaderMoreMenuProps> = ({ menus }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const openDropdown = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const closeDropdown = () => {
    setAnchorEl(null);
  };
  const isDropdownOpen = Boolean(anchorEl);

  const location = useLocation();
  useEffect(() => {
    closeDropdown();
  }, [location]);
  return (
    <>
      <Tooltip title="More Menus">
        <IconButton component="button" onClick={openDropdown} sx={desktopHeaderStyles.menuLink} color="secondary">
          <AppIcon Icon={HorizontalEllipsisIcon} titleAccess="See More Menus" />
        </IconButton>
      </Tooltip>
      {menus.length > 0 && (
        <Popover
          onClose={closeDropdown}
          open={isDropdownOpen}
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          transformOrigin={{ vertical: 'top', horizontal: 'center' }}
          PaperProps={{ sx: desktopHeaderStyles.moreMenuDropdown }}
        >
          <Grid container direction="column" spacing={4}>
            {menus.map((menu) => (
              <Grid key={menu.id} xs item>
                <Button
                  component={Link}
                  to={menu.link}
                  color="primary"
                  sx={[desktopHeaderStyles.menuLink, desktopHeaderStyles.moreMenuParentLink]}
                >
                  {menu.display_name}
                </Button>
                {menu.children && menu.children.length > 0 && (
                  <>
                    <Divider sx={desktopHeaderStyles.moreMenuDivider} />
                    <DropdownMenuList menu={menu} />
                  </>
                )}
              </Grid>
            ))}
          </Grid>
        </Popover>
      )}
    </>
  );
};
